/**
 * Canonical ids for the LaunchPad themes registered in App.tsx.
 *
 * Shared so the theme registration, the first-visit default, and the sidebar
 * toggle all agree on the same string ids.
 */
export const LIGHT_THEME_ID = 'launchpad-light';
export const DARK_THEME_ID = 'launchpad-dark';
